import { useSyncExternalStore } from 'react';
import { getAuthModule } from '../install';
export function useAuthStatus() {
    const module = getAuthModule();
    return useSyncExternalStore((listener) => module.subscribe(listener), () => module.getStatus(), () => module.getStatus());
}
